import { MediumIcon } from "../IconSizes";

export const stenaAngleDown: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M11.54 14.96C11.93 15.35 12.57 15.35 12.96 14.96L17.71 10.21C18.1 9.82 18.1 9.18 17.71 8.79 17.32 8.4 16.68 8.4 16.29 8.79L12.25 12.84 8.21 8.79C7.82 8.4 7.18 8.4 6.79 8.79 6.4 9.18 6.4 9.82 6.79 10.21L11.54 14.96Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaAngleDownDouble: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M7.71 11.29L12.27 15.86 16.84 11.29C17.23 10.9 17.86 10.9 18.25 11.29 18.64 11.68 18.64 12.32 18.25 12.71L13.01 17.95C12.83 18.13 12.59 18.23 12.36 18.24L12.18 18.24C11.95 18.23 11.72 18.13 11.54 17.95L6.29 12.71C5.9 12.32 5.9 11.68 6.29 11.29 6.68 10.9 7.32 10.9 7.71 11.29ZM7.71 5.29L12.27 9.86 16.84 5.29C17.23 4.9 17.86 4.9 18.25 5.29 18.64 5.68 18.64 6.32 18.25 6.71L13.01 11.95C12.83 12.13 12.59 12.23 12.36 12.24L12.18 12.24C11.95 12.23 11.72 12.13 11.54 11.95L6.29 6.71C5.9 6.32 5.9 5.68 6.29 5.29 6.68 4.9 7.32 4.9 7.71 5.29Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaAngleLeft: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M14.96 6.79C14.57 6.4 13.93 6.4 13.54 6.79L8.79 11.54C8.4 11.93 8.4 12.57 8.79 12.96L13.54 17.71C13.93 18.1 14.57 18.1 14.96 17.71 15.35 17.32 15.35 16.68 14.96 16.29L10.91 12.25 14.96 8.21C15.33 7.83 15.35 7.23 14.99 6.83L14.96 6.79Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaAngleLeftDouble: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M11.54 6.79C11.93 6.4 12.57 6.4 12.96 6.79L12.99 6.83C13.35 7.23 13.33 7.83 12.96 8.21L8.91 12.25 12.96 16.29C13.35 16.68 13.35 17.32 12.96 17.71 12.57 18.1 11.93 18.1 11.54 17.71L6.79 12.96C6.4 12.57 6.4 11.93 6.79 11.54L11.54 6.79ZM16.29 6.79C16.68 6.4 17.32 6.4 17.71 6.79L17.74 6.83C18.1 7.23 18.08 7.83 17.71 8.21L13.66 12.25 17.71 16.29C18.1 16.68 18.1 17.32 17.71 17.71 17.32 18.1 16.68 18.1 16.29 17.71L11.54 12.96C11.15 12.57 11.15 11.93 11.54 11.54L16.29 6.79Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaAngleRight: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M8.79 6.79C9.18 6.4 9.82 6.4 10.21 6.79L14.96 11.54C15.35 11.93 15.35 12.57 14.96 12.96L10.21 17.71C9.82 18.1 9.18 18.1 8.79 17.71 8.4 17.32 8.4 16.68 8.79 16.29L12.84 12.25 8.79 8.21C8.42 7.83 8.4 7.23 8.76 6.83L8.79 6.79Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaAngleRightDouble: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12.96 6.79L17.71 11.54C18.1 11.93 18.1 12.57 17.71 12.96L12.96 17.71C12.57 18.1 11.93 18.1 11.54 17.71 11.15 17.32 11.15 16.68 11.54 16.29L15.59 12.25 11.54 8.21C11.17 7.83 11.15 7.23 11.51 6.83L11.54 6.79C11.93 6.4 12.57 6.4 12.96 6.79ZM8.21 6.79L12.96 11.54C13.35 11.93 13.35 12.57 12.96 12.96L8.21 17.71C7.82 18.1 7.18 18.1 6.79 17.71 6.4 17.32 6.4 16.68 6.79 16.29L10.84 12.25 6.79 8.21C6.42 7.83 6.4 7.23 6.76 6.83L6.79 6.79C7.18 6.4 7.82 6.4 8.21 6.79Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaAngleUp: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M11.54 8.79C11.93 8.4 12.57 8.4 12.96 8.79L17.71 13.54C18.1 13.93 18.1 14.57 17.71 14.96 17.32 15.35 16.68 15.35 16.29 14.96L12.25 10.91 8.21 14.96C7.82 15.35 7.18 15.35 6.79 14.96 6.4 14.57 6.4 13.93 6.79 13.54L11.54 8.79Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaAngleUpDouble: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M7.71 11.95L12.27 7.38 16.84 11.95C17.23 12.34 17.86 12.34 18.25 11.95 18.64 11.56 18.64 10.92 18.25 10.53L13.01 5.29C12.83 5.11 12.59 5.01 12.36 5L12.18 5C11.95 5.01 11.72 5.11 11.54 5.29L6.29 10.53C5.9 10.92 5.9 11.56 6.29 11.95 6.68 12.34 7.32 12.34 7.71 11.95ZM7.71 17.95L12.27 13.38 16.84 17.95C17.23 18.34 17.86 18.34 18.25 17.95 18.64 17.56 18.64 16.92 18.25 16.53L13.01 11.29C12.83 11.11 12.59 11.01 12.36 11L12.18 11C11.95 11.01 11.72 11.11 11.54 11.29L6.29 16.53C5.9 16.92 5.9 17.56 6.29 17.95 6.68 18.34 7.32 18.34 7.71 17.95Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowCircleDown: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12.15 6.35C12.71 6.35 13.15 6.79 13.15 7.35L13.15 14.39 15.45 12.13C15.82 11.77 16.4 11.75 16.8 12.07L16.86 12.13C17.25 12.5 17.25 13.11 16.86 13.48L12.86 17.37C12.47 17.75 11.84 17.75 11.45 17.37L7.45 13.48C7.06 13.11 7.06 12.5 7.45 12.13 7.84 11.75 8.47 11.75 8.86 12.13L11.15 14.39 11.15 7.35C11.15 6.79 11.6 6.35 12.15 6.35Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowCircleLeft: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM10.67 7.29C11.05 6.9 11.65 6.9 12.03 7.29L12.08 7.36C12.4 7.75 12.38 8.34 12.03 8.71L9.77 11 16.81 11C17.36 11 17.81 11.45 17.81 12 17.81 12.55 17.36 13 16.81 13L9.77 13 12.03 15.29C12.4 15.68 12.4 16.32 12.03 16.71 11.65 17.1 11.05 17.1 10.67 16.71L6.78 12.71C6.41 12.32 6.41 11.68 6.78 11.29L10.67 7.29Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowCircleRight: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM13.63 7.29L17.53 11.29C17.9 11.68 17.9 12.32 17.53 12.71L13.63 16.71C13.26 17.1 12.65 17.1 12.28 16.71 11.91 16.32 11.91 15.68 12.28 15.29L14.54 13 7.5 13C6.95 13 6.5 12.55 6.5 12 6.5 11.45 6.95 11 7.5 11L14.54 11 12.28 8.71C11.93 8.34 11.91 7.75 12.22 7.36L12.28 7.29C12.65 6.9 13.26 6.9 13.63 7.29Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowCircleUp: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M12 0C18.63 0 24 5.37 24 12 24 18.63 18.63 24 12 24 5.37 24 0 18.63 0 12 0 5.37 5.37 0 12 0ZM12 2C6.48 2 2 6.48 2 12 2 17.52 6.48 22 12 22 17.52 22 22 17.52 22 12 22 6.48 17.52 2 12 2ZM12.86 6.63L16.86 10.52C17.25 10.89 17.25 11.5 16.86 11.87 16.47 12.25 15.84 12.25 15.45 11.87L13.15 9.61 13.15 16.65C13.15 17.21 12.71 17.65 12.15 17.65 11.6 17.65 11.15 17.21 11.15 16.65L11.15 9.65 11.16 9.61 8.86 11.87C8.49 12.23 7.9 12.25 7.51 11.93L7.45 11.87C7.06 11.5 7.06 10.89 7.45 10.52L11.45 6.63C11.84 6.25 12.47 6.25 12.86 6.63Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowDouble: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M7.22 12.29C6.85 11.9 6.24 11.9 5.87 12.29L1.97 16.29C1.6 16.68 1.6 17.32 1.97 17.71L5.87 21.71C6.24 22.1 6.85 22.1 7.22 21.71 7.59 21.32 7.59 20.68 7.22 20.29L4.96 18 15.5 18C16.05 18 16.5 17.55 16.5 17 16.5 16.45 16.05 16 15.5 16H5L4.96 16 7.22 13.71C7.57 13.34 7.59 12.75 7.28 12.36L7.22 12.29ZM18.33 2.29C17.95 1.9 17.35 1.9 16.97 2.29L16.92 2.36C16.6 2.75 16.62 3.34 16.97 3.71L19.23 6 19.19 6H8.69C8.14 6 7.69 6.45 7.69 7 7.69 7.55 8.14 8 8.69 8L19.23 8 16.97 10.29C16.6 10.68 16.6 11.32 16.97 11.71 17.35 12.1 17.95 12.1 18.33 11.71L22.22 7.71C22.59 7.32 22.59 6.68 22.22 6.29L18.33 2.29Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowDoubleBack: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.13 12.29L22.03 16.29C22.4 16.68 22.4 17.32 22.03 17.71L18.13 21.71C17.76 22.1 17.15 22.1 16.78 21.71 16.41 21.32 16.41 20.68 16.78 20.29L19.04 18 8.5 18C7.95 18 7.5 17.55 7.5 17 7.5 16.45 7.95 16 8.5 16L19 16 19.04 16 16.78 13.71C16.43 13.34 16.41 12.75 16.72 12.36L16.78 12.29C17.15 11.9 17.76 11.9 18.13 12.29ZM5.67 2.29C6.05 1.9 6.65 1.9 7.03 2.29L7.08 2.36C7.4 2.75 7.38 3.34 7.03 3.71L4.77 6 4.81 6 15.31 6C15.86 6 16.31 6.45 16.31 7 16.31 7.55 15.86 8 15.31 8L4.77 8 7.03 10.29C7.4 10.68 7.4 11.32 7.03 11.71 6.65 12.1 6.05 12.1 5.67 11.71L1.78 7.71C1.41 7.32 1.41 6.68 1.78 6.29L5.67 2.29Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowDoubleVertical: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M11.61 18.23L7.61 22.12C7.22 22.5 6.59 22.5 6.2 22.12L2.2 18.23C1.81 17.86 1.81 17.25 2.2 16.88 2.59 16.5 3.22 16.5 3.61 16.88L5.9 19.14 5.9 8.6C5.9 8.04 6.35 7.6 6.9 7.6 7.46 7.6 7.9 8.04 7.9 8.6L7.9 19.14 10.2 16.88C10.57 16.52 11.15 16.5 11.55 16.82L11.61 16.88C12 17.25 12 17.86 11.61 18.23ZM21.61 5.77C22 6.14 22 6.75 21.61 7.12L21.55 7.18C21.15 7.5 20.57 7.48 20.2 7.12L17.9 4.86 17.9 15.4C17.9 15.96 17.46 16.4 16.9 16.4 16.35 16.4 15.9 15.96 15.9 15.4L15.9 4.86 13.61 7.12C13.22 7.5 12.59 7.5 12.2 7.12 11.81 6.75 11.81 6.14 12.2 5.77L16.2 1.88C16.59 1.5 17.22 1.5 17.61 1.88L21.61 5.77Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowDown: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 5.5C13 4.95 12.55 4.5 12 4.5 11.45 4.5 11 4.95 11 5.5L11 16.19 11 16.23 8.71 13.97C8.34 13.62 7.75 13.6 7.36 13.92L7.29 13.97C6.9 14.35 6.9 14.95 7.29 15.33L11.29 19.22C11.68 19.59 12.32 19.59 12.71 19.22L16.71 15.33C17.1 14.95 17.1 14.35 16.71 13.97 16.32 13.6 15.68 13.6 15.29 13.97L13 16.23 13 5.5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowLeft: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M18.31 13C18.86 13 19.31 12.55 19.31 12 19.31 11.45 18.86 11 18.31 11L7.81 11 7.77 11 10.03 8.71C10.38 8.34 10.4 7.75 10.08 7.36L10.03 7.29C9.65 6.9 9.05 6.9 8.67 7.29L4.78 11.29C4.41 11.68 4.41 12.32 4.78 12.71L8.67 16.71C9.05 17.1 9.65 17.1 10.03 16.71 10.4 16.32 10.4 15.68 10.03 15.29L7.77 13 18.31 13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowPath: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M9 1C10.66 1 12 2.34 12 4L12 6C12 6.04 12 6.08 11.99 6.12 13.72 6.57 15 8.13 15 10 15 12.21 13.21 14 11 14 8.79 14 7 12.21 7 10 7 8.13 8.28 6.57 10.01 6.12L10 6 10 4C10 3.45 9.55 3 9 3L4.03 3C3.47 3 3.02 3.45 3.02 4L3.02 17C3.02 17.55 3.47 18 4.03 18L19.7 18 18.43 16.71C18.07 16.34 18.05 15.75 18.37 15.36L18.43 15.29C18.81 14.9 19.42 14.9 19.8 15.29L22.72 18.29C23.09 18.68 23.09 19.32 22.72 19.71L19.8 22.71C19.42 23.1 18.81 23.1 18.43 22.71 18.05 22.32 18.05 21.68 18.43 21.29L19.7 20 4.03 20C2.36 20 1 18.66 1 17L1 4C1 2.34 2.36 1 4.03 1L9 1ZM11 8C9.9 8 9 8.9 9 10 9 11.1 9.9 12 11 12 12.1 12 13 11.1 13 10 13 8.9 12.1 8 11 8Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowRight: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M5.5 13C4.95 13 4.5 12.55 4.5 12 4.5 11.45 4.95 11 5.5 11L16 11 16.04 11 13.78 8.71C13.43 8.34 13.41 7.75 13.72 7.36L13.78 7.29C14.15 6.9 14.76 6.9 15.13 7.29L19.03 11.29C19.4 11.68 19.4 12.32 19.03 12.71L15.13 16.71C14.76 17.1 14.15 17.1 13.78 16.71 13.41 16.32 13.41 15.68 13.78 15.29L16.04 13 5.5 13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowRightAngle: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M5.5 12L18.54 12 16.28 9.71C15.93 9.34 15.91 8.75 16.22 8.36L16.28 8.29C16.65 7.9 17.26 7.9 17.63 8.29L21.53 12.29C21.9 12.68 21.9 13.32 21.53 13.71L17.63 17.71C17.26 18.1 16.65 18.1 16.28 17.71 15.91 17.32 15.91 16.68 16.28 16.29L18.54 14 5.5 14C3.95 14 3 13.05 3 11.5L3 6C3 5.45 3.45 5 4 5 4.55 5 5 5.45 5 6L5 11.57C5.01 11.95 5.08 12 5.5 12Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowShortDown: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M10.9 7.1C10.9 6.54 11.35 6.1 11.9 6.1 12.46 6.1 12.9 6.54 12.9 7.1L12.9 14.64 15.2 12.38C15.57 12.02 16.15 12 16.55 12.32L16.61 12.38C17 12.75 17 13.36 16.61 13.73L12.61 17.62C12.22 18 11.59 18 11.2 17.62L7.2 13.73C6.81 13.36 6.81 12.75 7.2 12.38 7.59 12 8.22 12 8.61 12.38L10.9 14.64 10.9 7.1Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowShortLeft: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M16.81 13C17.36 13 17.81 12.55 17.81 12 17.81 11.45 17.36 11 16.81 11L9.27 11 11.53 8.71C11.88 8.34 11.9 7.75 11.58 7.36L11.53 7.29C11.15 6.9 10.55 6.9 10.17 7.29L6.28 11.29C5.91 11.68 5.91 12.32 6.28 12.71L10.17 16.71C10.55 17.1 11.15 17.1 11.53 16.71 11.9 16.32 11.9 15.68 11.53 15.29L9.27 13 16.81 13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowShortRight: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M7 13C6.45 13 6 12.55 6 12 6 11.45 6.45 11 7 11L14.5 11 14.54 11 12.28 8.71C11.93 8.34 11.91 7.75 12.22 7.36L12.28 7.29C12.65 6.9 13.26 6.9 13.63 7.29L17.53 11.29C17.9 11.68 17.9 12.32 17.53 12.71L13.63 16.71C13.26 17.1 12.65 17.1 12.28 16.71 11.91 16.32 11.91 15.68 12.28 15.29L14.54 13 7 13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowShortUp: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M10.9 16.9C10.9 17.46 11.35 17.9 11.9 17.9 12.46 17.9 12.9 17.46 12.9 16.9L12.9 9.36 15.2 11.62C15.57 11.98 16.15 12 16.55 11.68L16.61 11.62C17 11.25 17 10.64 16.61 10.27L12.61 6.38C12.22 6 11.59 6 11.2 6.38L7.2 10.27C6.81 10.64 6.81 11.25 7.2 11.62 7.59 12 8.22 12 8.61 11.62L10.9 9.36 10.9 16.9Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowUp: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 18.5C13 19.05 12.55 19.5 12 19.5 11.45 19.5 11 19.05 11 18.5L11 7.81 11 7.77 8.71 10.03C8.34 10.38 7.75 10.4 7.36 10.08L7.29 10.03C6.9 9.65 6.9 9.05 7.29 8.67L11.29 4.78C11.68 4.41 12.32 4.41 12.71 4.78L16.71 8.67C17.1 9.05 17.1 9.65 16.71 10.03 16.32 10.4 15.68 10.4 15.29 10.03L13 7.77 13 18.5Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowWideDown: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 1.51C13 0.95 12.55 0.5 12 0.5 11.45 0.5 11 0.95 11 1.51L11 20.2 8.71 17.93C8.34 17.57 7.75 17.55 7.36 17.87L7.29 17.93C6.9 18.3 6.9 18.91 7.29 19.29L11.29 23.22C11.68 23.59 12.32 23.59 12.71 23.22L16.71 19.29C17.1 18.91 17.1 18.3 16.71 17.93 16.32 17.55 15.68 17.55 15.29 17.93L13 20.21 13 1.51Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowWideLeft: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M22.31 13C22.86 13 23.31 12.55 23.31 12 23.31 11.45 22.86 11 22.31 11L3.81 11 3.77 11 6.03 8.71C6.38 8.34 6.4 7.75 6.08 7.36L6.03 7.29C5.65 6.9 5.05 6.9 4.67 7.29L0.78 11.29C0.41 11.68 0.41 12.32 0.78 12.71L4.67 16.71C5.05 17.1 5.65 17.1 6.03 16.71 6.4 16.32 6.4 15.68 6.03 15.29L3.77 13 22.31 13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowWideRight: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M1.5 13C0.95 13 0.5 12.55 0.5 12 0.5 11.45 0.95 11 1.5 11L20 11 20.04 11 17.78 8.71C17.43 8.34 17.41 7.75 17.72 7.36L17.78 7.29C18.15 6.9 18.76 6.9 19.13 7.29L23.03 11.29C23.4 11.68 23.4 12.32 23.03 12.71L19.13 16.71C18.76 17.1 18.15 17.1 17.78 16.71 17.41 16.32 17.41 15.68 17.78 15.29L20.04 13 1.5 13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaArrowWideUp: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M13 22.49C13 23.05 12.55 23.5 12 23.5 11.45 23.5 11 23.05 11 22.49L11 3.84 11 3.8 8.71 6.07C8.34 6.43 7.75 6.45 7.36 6.13L7.29 6.07C6.9 5.7 6.9 5.09 7.29 4.71L11.29 0.78C11.68 0.41 12.32 0.41 12.71 0.78L16.71 4.71C17.1 5.09 17.1 5.7 16.71 6.07 16.32 6.45 15.68 6.45 15.29 6.07L13 3.79 13 22.49Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaCompress: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M14 11C13.45 11 13 10.55 13 10L13 5C13 4.45 13.45 4 14 4 14.55 4 15 4.45 15 5L15 7.64 22.31 0.29C22.7-0.1 23.33-0.1 23.71 0.29 24.1 0.67 24.1 1.3 23.71 1.69L16.36 9 19 9C19.55 9 20 9.45 20 10 20 10.55 19.55 11 19 11L14 11ZM10 13C10.55 13 11 13.45 11 14L11 19C11 19.55 10.55 20 10 20 9.45 20 9 19.55 9 19L9 16.36 1.69 23.71C1.3 24.1 0.67 24.1 0.29 23.71-0.1 23.33-0.1 22.7 0.29 22.31L7.63 15 5 15C4.45 15 4 14.55 4 14 4 13.45 4.45 13 5 13L10 13Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaExpand: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M2 16C2 15.45 2.45 15 3 15 3.55 15 4 15.45 4 16L4 18.64 10.31 12.29C10.7 11.9 11.33 11.9 11.71 12.29 12.1 12.67 12.1 13.3 11.71 13.69L5.36 20 8 20C8.55 20 9 20.45 9 21 9 21.55 8.55 22 8 22L3 22C2.45 22 2 21.55 2 21L2 16ZM21 2C21.55 2 22 2.45 22 3L22 8C22 8.55 21.55 9 21 9 20.45 9 20 8.55 20 8L20 5.36 13.69 11.71C13.3 12.1 12.67 12.1 12.29 11.71 11.9 11.33 11.9 10.7 12.29 10.31L18.64 4 16 4C15.45 4 15 3.55 15 3 15 2.45 15.45 2 16 2L21 2Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaMerge: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M9 0C10.66 0 12 1.34 12 3L12 9C12 10.32 12.65 10.99 13.96 11L20 11 20.04 11 18.78 9.71C18.43 9.34 18.41 8.75 18.72 8.36L18.78 8.29C19.15 7.9 19.76 7.9 20.13 8.29L23.03 11.29C23.4 11.68 23.4 12.32 23.03 12.71L20.13 15.71C19.76 16.1 19.15 16.1 18.78 15.71 18.41 15.32 18.41 14.68 18.78 14.29L20.04 13 14 13C12.73 13 12.06 13.61 12 14.82L12 15 12 21C12 22.66 10.66 24 9 24L2 24C1.45 24 1 23.55 1 23 1 22.45 1.45 22 2 22L9 22C9.55 22 10 21.55 10 21L10 3C10 2.45 9.55 2 9 2L2 2C1.45 2 1 1.55 1 1 1 0.45 1.45 0 2 0L9 0Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSailingRoundTrip: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M3.35 12.76L4.93 14.4C5.28 14.76 5.28 15.36 4.93 15.73 4.58 16.09 4.02 16.09 3.68 15.73L0.76 12.66C0.41 12.3 0.41 11.7 0.76 11.34L3.68 8.27C3.83 8.11 4.03 8.02 4.23 8L4.3 8C4.53 8 4.76 8.09 4.93 8.27L4.98 8.33C5.28 8.7 5.26 9.26 4.93 9.6L3.35 11.24 20.65 11.24 19.07 9.6C18.72 9.24 18.72 8.64 19.07 8.27 19.42 7.91 19.98 7.91 20.32 8.27L23.24 11.34C23.59 11.7 23.59 12.3 23.24 12.66L20.32 15.73C20.17 15.89 19.97 15.98 19.77 16L19.7 16C19.47 16 19.24 15.91 19.07 15.73L19.02 15.67C18.72 15.3 18.74 14.74 19.07 14.4L20.65 12.76 3.35 12.76Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};

export const stenaSync: MediumIcon = {
  icon: [
    24,
    24,
    [],
    "",
    "M9.57 4.29C9.95 4.68 9.95 5.32 9.57 5.71L8.3 7 20.97 7C22.64 7 24 8.34 24 10L24 21C24 22.66 22.64 24 20.97 24L11 24C9.34 24 8 22.66 8 21L8 20C8 19.45 8.45 19 9 19 9.51 19 9.94 19.39 9.99 19.88L10 20 10 21C10 21.55 10.45 22 11 22L20.97 22C21.53 22 21.98 21.55 21.98 21L21.98 10C21.98 9.45 21.53 9 20.97 9L8.3 9 9.57 10.29C9.93 10.66 9.95 11.25 9.63 11.64L9.57 11.71C9.19 12.1 8.58 12.1 8.2 11.71L5.28 8.71C4.91 8.32 4.91 7.68 5.28 7.29L8.2 4.29C8.58 3.9 9.19 3.9 9.57 4.29ZM13 0C14.66 0 16 1.34 16 3L16 4C16 4.55 15.55 5 15 5 14.45 5 14 4.55 14 4L14 3C14 2.45 13.55 2 13 2L3 2C2.45 2 2 2.45 2 3L2 14C2 14.55 2.45 15 3 15L15.54 15 14.28 13.71C13.93 13.34 13.91 12.75 14.22 12.36L14.28 12.29C14.65 11.9 15.26 11.9 15.63 12.29L18.53 15.29C18.9 15.68 18.9 16.32 18.53 16.71L15.63 19.71C15.26 20.1 14.65 20.1 14.28 19.71 13.91 19.32 13.91 18.68 14.28 18.29L15.54 17 3 17C1.34 17 0 15.66 0 14L0 3C0 1.34 1.34 0 3 0L13 0Z",
  ],
  iconName: "random",
  prefix: "fal",
  size: "medium",
};
